import React from 'react';
/* eslint-disable */
export function ConnectGradient(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M22.5 19.25C20.4289 19.25 18.75 20.9289 18.75 23C18.75 25.0711 20.4289 26.75 22.5 26.75C24.5711 26.75 26.25 25.0711 26.25 23C26.25 20.9289 24.5711 19.25 22.5 19.25ZM22.5 19.25V10.5C22.5 9.83696 22.2366 9.20107 21.7678 8.73223C21.2989 8.26339 20.663 8 20 8H16.25M7.5 11.75C9.57107 11.75 11.25 10.0711 11.25 8C11.25 5.92893 9.57107 4.25 7.5 4.25C5.42893 4.25 3.75 5.92893 3.75 8C3.75 10.0711 5.42893 11.75 7.5 11.75ZM7.5 11.75V26.75"
        stroke="url(#paint0_linear_1853_5058)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1853_5058"
          x1="15"
          y1="26.75"
          x2="15"
          y2="4.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF512F" />
          <stop offset="1" stopColor="#DD2476" />
        </linearGradient>
      </defs>
    </svg>
  );
}
